import { Pipe, PipeTransform } from '@angular/core'
import { LocalizationService } from '@app-domains/localization/service/localization.service'
import { PositionedPageEnum } from '@app-graphql/schema'
import { PageService } from '@app-services'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Pipe({
    name: 'positionedPageTitle',
    standalone: false,
})
export class PositionedPageTitlePipe implements PipeTransform {

    constructor(
        private localization: LocalizationService,
        private positionedPageService: PageService,
    ) {
    }

    transform(identifier: PositionedPageEnum, defaultValue?: string): Observable<string | null> {
        return combineLatest([
            this.positionedPageService.slugsTable$,
            this.localization.currentLocale$,
        ]).pipe(
            map(([table, locale]) => {
                const entries = table?.[identifier] ?? []
                const matched = entries.find(entry => entry[locale]?.title)
                return matched?.[locale]?.title ?? defaultValue ?? null
            }),
        )
    }

}
